import React from "react";

export const YellowQuestion: React.FC<{}> = () => {
  return (
    <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Links/z.parts/Yellow-Small Icon</title>
      <g
        id="11th-Year-Renewal"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="10th-YR---Step-3---Review-and-Pay-Error-*"
          transform="translate(-209.000000, -617.000000)"
        >
          <g id="Group" transform="translate(207.000000, 615.000000)">
            <rect id="Rectangle" x="0" y="0" width="20" height="20" />
            <circle id="Oval" fill="#FFCF00" cx="10" cy="10" r="7.125" />
            <path
              d="M10,11.78125 L10,10.7125 C11.3116763,10.7125 12.375,9.64917628 12.375,8.3375 C12.375,7.02582372 11.3116763,5.9625 10,5.9625 C8.68832372,5.9625 7.625,7.02582372 7.625,8.3375"
              id="Path"
              stroke="#252525"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle id="Oval" fill="#252525" cx="10" cy="13.859375" r="1" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default {};
